<div class="info-box course-box box-shadow-none all-class-box my-4"
  [ngClass]="{'active': (crntUser.userId == classData?.teacher?.umlId && !isMySchedule)}">
  <div class="d-md-block d-sm-none">
    <div class="d-flex">
      <div class="teacher-img" *ngIf="isShownProfileImg">
        <img [src]="classData?.teacher?.profileImage" (error)="_helper.profileImgError($event)" alt="">
      </div>
      <div class="pl-2 teacher-details align-self-start flex-fill">
        <div class="d-flex justify-content-between">
          <div class="course-subject">
            <img src="assets/img/subject-icons/{{classData?.subject | lowercase }}-icon.svg" alt="">
            <span>{{classData?.subject}}</span>
          </div>

          <div class="date-box d-none d-sm-none d-md-block">

            <p>
              <span class="LCS_feedback mr-4" *ngIf="classData?.classReview">
                <img src="assets/img/thumb-up-icon.svg" class="mr-2" alt="" />
                {{classData?.classReview}}
              </span>
              {{classData?.schedule?.startDate | date: 'd MMM, YYYY'}}
              <span>
                {{classData?.schedule?.startTime | date: 'shortTime'}} - {{classData?.schedule?.endTime | date:
                'shortTime'}}</span>
            </p>
            <div class="ml-auto" *ngIf="isMySchedule"
              [ngClass]="{'bd-live': (isTodaySchedule && isStatusLive), 'bd-upcoming': ((isTodaySchedule && !isStatusLive) || (isTomorrowSchedule) || (!isTomorrowSchedule && scheduleWaitingDays > 0)), 'bd-recorded': (isPastSchedule && isMeetingAttended), 'bd-absent': (isPastSchedule && !isMeetingAttended)}">
              {{getClassStatusText()}}
            </div>
          </div>
        </div>
        <h4>{{classData?.title}}</h4>
        <div class="small-details sm-course-details">
          <div class="w-100 w-sm-auto top-info">
            <ng-container *ngIf="crntUser.userId == classData?.teacher?.umlId">
              <span><img src="assets/img/grad-cap.png" alt=""> Grade {{classData?.grade}}</span>
              <span>{{classData?.language | uppercase}}</span>
            </ng-container>
            <ng-container *ngIf="crntUser.userId != classData?.teacher?.umlId">
              <span>By {{classData?.teacher?.name}}</span>
            </ng-container>
          </div>
        </div>
        <div class="d-flex justify-content-between flex-sm-row flex-column mt-2 bottom-holder flex-wrap"
          *ngIf="crntUser.userId == classData?.teacher?.umlId">
          <div class="d-flex flex-wrap align-self-center">
            <app-custom-button *ngIf="isTodaySchedule && showJoinNow" type="button"
              [cta]="{name:'join Now',type:'teacherJoinNow', dataType: '', data:classData}"></app-custom-button>

            <app-custom-button *ngIf="type == 'past' && isMyCoursePage && !isMeetingAttended && isMySchedule"
              type="button" [cta]="{name:'missed',type:'rescheduled', dataType: '', data:classData}">
            </app-custom-button>

            <app-custom-button *ngIf="type == 'past' && (!isMyCoursePage || isMeetingAttended)" type="button"
              [cta]="{name:'rewatch',type:'rewatch', dataType: '', data:classData}"></app-custom-button>

            <app-custom-button *ngIf="!(type == 'past' && isMyCoursePage && !isMeetingAttended && isMySchedule)"
              type="button" [cta]="{name:'view session',type:'teacherViewSession', dataType: '', data:classData}">
            </app-custom-button>
          </div>

          <p class="student-joining-note" *ngIf="type == 'upcoming'"><img src="assets/img/star.svg" alt="">
            {{classData.registeredStudent}} students have registered for this class</p>
          <p class="student-joining-note" *ngIf="type == 'ongoing'"><img src="assets/img/star.svg" alt="">
            {{classData.attendyStudent}}/{{classData.registeredStudent}} students are attending this class</p>
          <p class="student-joining-note" *ngIf="type == 'past'"><img src="assets/img/star.svg" alt="">
            {{classData.attendyStudent}}/{{classData.registeredStudent}} attended this class</p>


          <div class="d-flex flex-wrap pr-3">

            <button *ngIf="classData?.notes?.length>0" class="btn btn-outline-secondary mr-2 flex-fill" type="button"
              (click)="previewDocument(classData.notes[0])">NOTES
              <img class="ml-1 mr-2" src="assets/img/note-icon.svg" />
            </button>

            <button type="button" class="btn btn-outline-secondary flex-fill disabled"
              *ngIf="classData?.assignments?.length > 0" (click)="previewDocument(classData?.assignments[0])">
              Assignments <img class=" ml-1 mr-2" src="assets/img/assignments-icon.svg" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-md-none d-sm-block">
    <div class="d-flex">
      <div class="teacher-img" *ngIf="isShownProfileImg">
        <img src="assets/img/empty-profile.svg" alt="" style="width: 80px;">
      </div>
      <div class="course-subject top-res-details d-md-none d-sm-block">
        <img src="assets/img/subject-icons/{{classData?.subject | lowercase }}-icon.svg" alt="">
        <span>{{classData?.subject}}</span>
      </div>
      <div class="pl-2 teacher-details align-self-start flex-fill">
        <h4>{{classData?.title}}</h4>
        <div class="d-md-none d-sm-block">
          <div class="date-box">
            <p>
              {{classData?.schedule?.startDate | date: 'd MMM, YYYY'}}
              <span> {{classData?.schedule?.startTime | date: 'shortTime'}} - {{classData?.schedule?.endTime | date:
                'shortTime'}}</span>
            </p>
            <div *ngIf="isMySchedule" class="ml-auto"
              [ngClass]="{'bd-live': (isTodaySchedule && isStatusLive), 'bd-upcoming': ((isTodaySchedule && !isStatusLive) || (isTomorrowSchedule) || (!isTomorrowSchedule && scheduleWaitingDays > 0)), 'bd-recorded': isPastSchedule}">
              {{getClassStatusText()}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="small-details sm-course-details position-relative">
      <div class="w-100 w-sm-auto top-info">
        <ng-container *ngIf="crntUser.userId == classData?.teacher?.umlId">
          <span><img src="assets/img/grad-cap.png" alt=""> Grade {{classData?.grade}}</span>
          <span>{{classData?.language | uppercase}}</span>
        </ng-container>
        <ng-container *ngIf="crntUser.userId != classData?.teacher?.umlId">
          <span>By {{classData?.teacher?.name}}</span>
        </ng-container>
      </div>
    </div>
    <div class="d-flex justify-content-between flex-sm-row flex-column mt-4 bottom-holder flex-wrap"
      *ngIf="crntUser.userId == classData?.teacher?.umlId">
      <div class="d-flex flex-wrap align-self-center w-100">
        <app-custom-button *ngIf="type == 'ongoing'" type="button"
          [cta]="{name:'join Now',type:'teacherJoinNow', dataType: '', data:classData}"></app-custom-button>

        <app-custom-button *ngIf="type == 'past' && (isMyCoursePage && !isMeetingAttended && isMySchedule)"
          type="button" [cta]="{name:'missed',type:'rescheduled', dataType: '', data:classData}"></app-custom-button>

        <app-custom-button *ngIf="type == 'past'" type="button"
          [cta]="{name:'rewatch',type:'rewatch', dataType: '', data:classData}"></app-custom-button>

        <app-custom-button type="button"
          [cta]="{name:'VIEW SESSION',type:'teacherViewSession', dataType: '', data:classData}"></app-custom-button>
      </div>

      <div class="d-flex flex-wrap">
        <button *ngIf="classData?.notes?.length>0" class="btn btn-outline-secondary mr-2 flex-fill" type="button"
          (click)="previewDocument(classData.notes[0])">NOTES <img class="ml-1" src="assets/img/note-icon.svg" alt="" />
        </button>
        <button *ngIf="classData?.assignments?.length>0" type="button"
          (click)="previewDocument(classData.assignments[0])"
          class="btn btn-outline-secondary flex-fill ">Assignments<img class="ml-1"
            src="assets/img/assignments-icon.svg" alt=""> </button>

        <p class="student-joining-note" *ngIf="type == 'upcoming'"><img src="assets/img/star.svg" alt="">
          {{classData.registeredStudent}} students have registered for this class</p>
        <p class="student-joining-note" *ngIf="type == 'ongoing'"><img src="assets/img/star.svg" alt="">
          {{classData.attendyStudent}}/{{classData.registeredStudent}} students are attending this class</p>
        <p class="student-joining-note" *ngIf="type == 'past'"><img src="assets/img/star.svg" alt="">
          {{classData.attendyStudent}}/{{classData.registeredStudent}} attended this class</p>
      </div>
    </div>
  </div>
</div>
